import { render, staticRenderFns } from "./BetonIndex.vue?vue&type=template&id=8f11edfe&scoped=true&"
import script from "./BetonIndex.vue?vue&type=script&lang=js&"
export * from "./BetonIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f11edfe",
  null
  
)

export default component.exports